module.exports = __webpack_public_path__ + "img/Princeton_NZA_Interim_Report_15_Dec_2020_FINAL.pdf";